import NeighborhoodPage from "@/components/NeighborhoodPage";
import heroImage from "@/assets/hero-recreio-dos-bandeirantes.jpg?w=640;1024;1600;1920&format=avif;webp;jpg&as=picture";

const RecreioDosBandeirantes = () => (
  <NeighborhoodPage
    name="Recreio dos Bandeirantes"
    slug="recreio-dos-bandeirantes"
    description="Praias paradisíacas, natureza exuberante e condomínios de alto padrão. O Recreio oferece qualidade de vida com tranquilidade e infraestrutura completa."
    heroPicture={heroImage}
  />
);

export default RecreioDosBandeirantes;
